import React, { FormEventHandler, ReactNode, FocusEventHandler } from 'react';
import './Person.pcss';

import PersonGender, { Sex } from '../PersonGender/PersonGender';
import FIO, { FIOProps } from '../FIO/FIO';
import { PERSON_FIELD_NAME } from '../../../constants/fieldNames';
import { ChangeFIOProps } from '../ChangeFIO/ChangeFIO';
import Citizenship from '../Citizenship/Citizenship';
import { getPersonPlaceholder } from '../../../helpers/getPlacelholder';
import {
  maxAcceptableDate,
  minAcceptableDate,
} from '../../../helpers/dateHelpers';
import { ERROR_DATE } from '../../../constants/errors';
import DateField from '../DateField/DateField';
import { getNewKey } from '../../../helpers/getNewKey';

export interface PersonProps extends FIOProps, ChangeFIOProps {
  birthdate: string;
  sex?: Sex;
  children: ReactNode;
}

export interface PersonComponentProps {
  // TODO - declare person field
  person: any;
  onChange: FormEventHandler;
  onBlur: FormEventHandler;
  handleFIOBlur: FocusEventHandler;

  onCitizenshipChange(value): void;

  model: string;
  children: ReactNode;
}

function Person({
  person,
  onChange,
  children,
  model,
  onBlur,
  handleFIOBlur,
  onCitizenshipChange,
}: PersonComponentProps): JSX.Element {
  const {
    birthdate: birthdateField,
    name: nameField,
    surname: surnameField,
    patronymic: patronymicField,
  } = PERSON_FIELD_NAME;
  const nameFields = [surnameField, nameField, patronymicField];
  const {
    name,
    surname,
    patronymic,
    birthdate,
    citizenship,
    isPatronymicAbsent,
    sex,
  } = person;
  const fields = { name, surname, patronymic, isPatronymicAbsent };

  return (
    <div className="Person">
      <FIO
        nameFields={nameFields}
        onChange={onChange}
        onBlur={handleFIOBlur}
        {...fields}
      />
      {children || (
        <div className="PguFormGrid__row">
          <div className="PguFormGrid_col PguFormGrid__col_3">
            <DateField
              errorLocation={
                [
                  ERROR_DATE.BIRTHDATE_EARLY_MARRIAGE_DATE,
                  ERROR_DATE.DOCUMENT_DATE_EARLY_BIRTHDATE,
                  ERROR_DATE.DOCUMENT_DATE_EARLY_THAN_14,
                ].includes(birthdate.error)
                  ? 'tooltip'
                  : 'placeholder'
              }
              value={birthdate.value}
              disabled={birthdate.disabled}
              error={birthdate.error}
              placeholder={getPersonPlaceholder('birthdate')}
              name={birthdateField}
              minDate={minAcceptableDate}
              maxDate={maxAcceptableDate}
              onChange={onChange}
              onBlur={onBlur}
            />
          </div>
        </div>
      )}
      <PersonGender sex={sex} onChange={onChange} model={model} />
      <Citizenship
        {...citizenship}
        onChange={onCitizenshipChange}
        newKey={model === 'child' ? getNewKey(person.id) : ''}
      />
    </div>
  );
}

export default Person;
